// src/components/CustomerSupportPage/CustomerSupportPage.jsx
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button } from "reactstrap";
import "../../assets/css/--component-customer-support.css";
import ConfirmationModal from "../../components/StatusModal";
import { postSupportRequest } from "../../helper/backend-methods";
import { useNavigate } from "react-router-dom";

const CustomerSupportPage = () => {
  const [form, setForm] = useState({
    Name: "",
    Email: "",
    PhoneNumber: "",
    Subject: "",
    Message: "",
  });

  const [errors, setErrors] = useState({
    Name: "",
    Email: "",
    PhoneNumber: "",
    Subject: "",
  });

  const [showErrors, setShowErrors] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState(null);
  const history = useNavigate();
  const subjectOptions = ["Select", "Order issue", "Returns & Refund", "Product enquiry", "Others"];

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!form.Name.trim()) {
      newErrors.Name = "Full name is required";
      isValid = false;
    }

    if (!form.Email.trim()) {
      newErrors.Email = "Email address is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(form.Email)) {
      newErrors.Email = "Email address is invalid";
      isValid = false;
    }

    if (!form.PhoneNumber.trim()) {
      newErrors.PhoneNumber = "Phone number is required";
      isValid = false;
    } else if (!/^(\+1\s?)?(\(?\d{3}\)?)[\s.-]?\d{3}[\s.-]?\d{4}$/.test(form.PhoneNumber)) {
      newErrors.PhoneNumber = "Please enter a valid phone number";
      isValid = false;
    }

    if (!form.Subject) {
      newErrors.Subject = "Please select a subject";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form value
    setForm((p) => ({ ...p, [name]: value }));

    // If errors are being shown, clear just this field's error
    if (showErrors && errors[name]) {
      setErrors((p) => ({ ...p, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Show errors when submit is clicked
    setShowErrors(true);

    // Validate form
    if (!validateForm()) {
      return;
    }

    postSupportRequest(form)
      .then(({ data }) => {
        if (data.Status) {
          setShowModal(true);
        } else {
          alert("Failed to submit the ticket. Please try again.");
        }
      })
      .catch(() => {
        alert("An error occurred while submitting the ticket. Please try again.");
      });

    //setShowModal(true);

    // Reset form and errors
    setForm({
      Name: "",
      Email: "",
      PhoneNumber: "",
      Subject: "",
      Message: "",
    });

    setErrors({
      Name: "",
      Email: "",
      PhoneNumber: "",
      Subject: "",
    });

    setShowErrors(false);
  };
  const handleCancelSubmit = () => {
    setShowModal(false);
    history('/account/dashboard');
    // User cancelled, do nothing
  };

  useEffect(() => {
    const userData = localStorage.getItem("userinfo");
    if (userData) {
      setUser(JSON.parse(userData));
      setForm((p) => ({
        ...p,
        Name: JSON.parse(userData).FullName || "",
        Email: JSON.parse(userData).Email || "",
        PhoneNumber: JSON.parse(userData).Phone || "",
      }));
    }
  }, []);

  return (
    <section id="support-section" className="mt-5 ms-md-4 ms-0">
      <div>
        <h1 className="fs-30 text-blakish fw-600 mt-0 mb-0">Customer Support</h1>
        <span className="separator my-3" />
      </div>
      <div className="support-container mt-4">
        <Row className="support-row me-0 ms-0">
          {/* Left contact panel */}
          <Col md={4} className="left-panel-col pe-0 ps-0">
            <div className="left-panel">
              <div className="contact-box">
                <div className="contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(196,48,62,1)">
                    <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                  </svg>
                </div>
                <div className="contact-info">
                  <div className="contact-title">Call Us</div>
                  <div className="contact-sub">Speak directly with our team</div>
                  <div className="contact-phone">(802) 555-4321</div>
                </div>
              </div>

              <div className="contact-box mt-3">
                <div className="contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(196,48,62,1)">
                    <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829Z"></path>
                  </svg>
                </div>
                <div className="contact-info">
                  <div className="contact-title">Email Us</div>
                  <div className="contact-sub">We'll respond within 24 hours</div>
                  <div className="contact-phone">support@mainscountry.com</div>
                </div>
              </div>
            </div>
          </Col>

          {/* Right form card */}
          <Col md={8} className="card-supp">
            <div className="support-card">
              <CardBody className="support-card-body p-4 p-md-5">
                <div className="support-card-header">
                  <h3 className="card-title">Fill out the form. Our team will reach out to you as soon as possible.</h3>
                  <p className="card-sub">
                    Fields marked with <span className="required-asterisk">*</span> are mandatory.
                  </p>
                </div>

                <Form onSubmit={handleSubmit} className="support-form" noValidate>
                  <div className="mt-5 mb-5">
                    <Row className="pe-0 ps-0">
                      <Col md={6}>
                        <FormGroup>
                          <Label for="fullName">
                            Full Name <span className="required-asterisk">*</span>
                          </Label>
                          <Input
                            id="fullName"
                            name="Name"
                            value={form.Name}
                            onChange={handleChange}
                            className={showErrors && errors.Name ? "is-invalid" : ""}
                            placeholder="Sarah Johnson"
                            readOnly={user !== null}
                            maxLength={60}
                          />
                          {showErrors && errors.Name && <div className="invalid-feedback d-block">{errors.Name}</div>}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label for="email">
                            Email Address <span className="required-asterisk">*</span>
                          </Label>
                          <Input
                            id="email"
                            name="Email"
                            type="Email"
                            value={form.Email}
                            onChange={handleChange}
                            className={showErrors && errors.Email ? "is-invalid" : ""}
                            placeholder="sarah-js01@gmail.com"
                            readOnly={user !== null}
                            maxLength={100}
                          />
                          {showErrors && errors.Email && <div className="invalid-feedback d-block">{errors.Email}</div>}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="pe-0 ps-0">
                      <Col md={6}>
                        <FormGroup>
                          <Label for="phone">
                            Phone Number <span className="required-asterisk">*</span>
                          </Label>
                          <Input
                            id="phone"
                            name="PhoneNumber"
                            value={form.PhoneNumber}
                            onChange={handleChange}
                            className={showErrors && errors.PhoneNumber ? "is-invalid" : ""}
                            placeholder="+(264) 382 5726"
                            maxLength={20}
                            readOnly={user !== null}
                          />
                          {showErrors && errors.PhoneNumber && <div className="invalid-feedback d-block">{errors.PhoneNumber}</div>}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label for="subject">
                            Subject <span className="required-asterisk">*</span>
                          </Label>
                          <div className="select-wrapper position-relative">
                            <Input
                              type="select"
                              id="subject"
                              name="Subject"
                              value={form.Subject}
                              onChange={handleChange}
                              className={`${showErrors && errors.Subject ? "is-invalid" : ""} custom-select`}
                            >
                              {subjectOptions.map((s, i) => (
                                <option key={i} value={i === 0 ? "" : s}>
                                  {s}
                                </option>
                              ))}
                            </Input>
                            <div className="select-arrow">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="6 9 12 15 18 9"></polyline>
                              </svg>
                            </div>
                          </div>
                          {showErrors && errors.Subject && <div className="invalid-feedback d-block">{errors.Subject}</div>}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="pe-0 ps-0">
                      <Col md={12}>
                        <FormGroup>
                          <Label for="message">Additional Information <span className="char-count">{form.Message?.length || 0}/500</span></Label>
                          <Input
                            type="textarea"
                            id="message"
                            name="Message"
                            value={form.Message}
                            onChange={handleChange}
                            placeholder="Type your text here..."
                            rows={5}
                            maxLength={500}
                          />
                        </FormGroup>
                       
                      </Col>
                    </Row>
                  </div>

                  <div className="w-100">
                    <button type="submit" className="submit-button w-100">
                      SUBMIT A TICKET
                    </button>
                  </div>
                </Form>
              </CardBody>
            </div>
          </Col>
        </Row>
      </div>
      <ConfirmationModal
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        type="confirmation"
        title="Support Ticket Created"
        message={`Your ticket has been submitted. Our team will get back to you shortly.`}
        ButtonText="Back to Dashboard"
        onCancel={handleCancelSubmit}
      />
    </section>
  );
};

export default CustomerSupportPage;
